module.exports = {"data":{"site":{"siteMetadata":{"title":"IFGF Austin Church","keyword":"IFGF GISI Austin Indonesian International Full Gospel Fellowship Church Jesus Christ Community Killen San Antonio Texas Fellowship Together","description":"IFGF Austin Central Texas Church"}}},"layoutContext":{}}


//////////////////
// WEBPACK FOOTER
// ./~/json-loader!./.cache/json/layout-index.json
// module id = 121
// module chunks = 60335399758886 114276838955818